import React from 'react'
import StatusPage from './StatusPage'
import {useHistory} from 'react-router-dom'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

const TimedOut = () => {
  const history = useHistory()
  return (
    <StatusPage>
      <Typography variant='h5'>Uh-oh!</Typography>
      <Typography variant='body1'>The request timed out.</Typography>
      <br/>
      <Button fullWidth variant='contained' color='secondary' onClick={history.goBack}>Go Back!</Button>
    </StatusPage>
  )
}

export default TimedOut